export default __webpack_public_path__ + "static/media/dark_dark_pink.1de7607a.png";